import React from "react";
import { Carousel, Col, Row, Modal } from "react-bootstrap";

const chunkArray = (array, size) => {
  return array.reduce((result, item, index) => {
    const chunkIndex = Math.floor(index / size);
    if (!result[chunkIndex]) result[chunkIndex] = [];
    result[chunkIndex].push(item);
    return result;
  }, []);
};

const ModalShowImage = ({ show, onHide, images }) => {
  const grouped = chunkArray(images, 2); // 2 item per slide
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide(false);
      }}
      size="lg"
      centered
      indicators
    >
      <Modal.Body>Daftar Gambar Terpilih</Modal.Body>
      <Modal.Body>
        <Carousel>
          {grouped.map((group, i) => (
            <Carousel.Item key={i}>
              <Row>
                {group.map((item) => (
                  <Col md={6} key={item}>
                    <img
                      className="d-block w-100"
                      src={item}
                      alt={`slide-${i}-${item}`}
                      onClick={() => window.open(item)}
                    />
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
};

export default ModalShowImage;
